import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const slot = css`
  background-color: ${cssTheme.default.day.backgroundMinor};
  height: ${spacing(8)};

  :before {
    content: none;
  }

  :first-child {
    border-top-left-radius: ${spacing(2)};
    border-top-right-radius: ${spacing(2)};
  }

  :last-child {
    border-bottom-left-radius: ${spacing(2)};
    border-bottom-right-radius: ${spacing(2)};
  }
`
export const noDividerSlot = css`
  :before {
    content: none;
  }
`

export const segment = css`
  && {
    flex: 1;
    background: ${cssTheme.default.day.controlMinor};
  }
`
export const trail: Record<string, string> = {
  body_size_widget: css`
    min-inline-size: ${spacing(38)};
  `,
  loaders_widget: css`
    min-inline-size: ${spacing(14)};
  `,
}

export const imgContainer = css`
  max-inline-size: ${spacing(25.25)}; // 210px
  max-block-size: ${spacing(14)}; // 112px
  display: flex;
  align-items: end;
  height: 100%;
`
